import { render, staticRenderFns } from "./danceTable.vue?vue&type=template&id=143e04a4"
import script from "./danceTable.vue?vue&type=script&lang=js"
export * from "./danceTable.vue?vue&type=script&lang=js"
import style0 from "./danceTable.vue?vue&type=style&index=0&id=143e04a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports